import styled from 'styled-components'

export const IframeWrapper = styled.div`
  height: calc(100vh - 90px);
  width: 100%;
`
